import { getUserInfo } from '@/api/user'
import { getToken, setToken } from '@/utils/auth'
import { getQueryString } from "@/utils/queryString";


const state = {
    token: getToken(),
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    }
}

const actions = {
    getInfo({ commit }, code) {
		let state = getQueryString("state");
        return new Promise((resolve, reject) => {
            getUserInfo({
                requestType: "authorization",
                state: state,
                code: code
            }).then(res => {
                const data = res.obj
                if (data.token != undefined) {
                    commit('SET_TOKEN', data.token)
                    setToken(data.token)
                }
                resolve(res)
            }).catch(error => {
                reject(error)
            });
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
